module.exports = __webpack_public_path__ + "img/diplom.ca3245ea.gif";